import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Constants} from '../../common/constants';
import {FieldConfigName} from '../../../models';
import {ControlDialogOptionsHelper} from '../control-dialog-options-helper';

@Component({
  selector: 'app-email-input-dialog',
  templateUrl: './email-input-dialog.component.html'
})
export class EmailInputDialogComponent extends ControlDialogOptionsHelper implements OnInit {
  constants: any = Constants;
  editEmailInputForm: UntypedFormGroup;
  status: boolean;
  control: FieldConfigName;

  constructor(private formBuilder: UntypedFormBuilder,
              public dialogRef: MatDialogRef<EmailInputDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    if (data) {
      this.control = data.control || this.control;
    }
  }

  ngOnInit(): void {
    this.validateFormBuilder();
    this.editProperty(this.control);
  }

  validateFormBuilder(): void {
    this.editEmailInputForm = this.formBuilder.group({
      tooltip: ['', []],
      label: ['', []],
      placeholder: ['', []],
      isRequired: [false]
    });
  }

  editProperty(control: any): void {
    this.status = control.options.isRequired;
    this.editEmailInputForm.setValue({
      tooltip: control.options.tooltip || '',
      label: control.options.label,
      placeholder: control.options.placeholder || '',
      isRequired: control.options.isRequired
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.editEmailInputForm.invalid) {
      return;
    }
    this.dialogRef.close(this.editEmailInputForm.value);
  }

  onChange(event: any): void {
    this.status = !!event.checked;
  }
}
